<template>
  <div class="gallery-wrapper">
    <div class="thumbnail__list">
      <button
        v-for="image in images"
        :key="image.id"
        class="thumbnail"
        :class="{ 'thumbnail--active': image === activeImage }"
        @click="setActiveImage(image)"
      >
        <img
          :srcset="getThumbnailSrcset(image)"
          :src="getThumbnailSrc(image)"
          class="thumbnail__image"
        />
      </button>
    </div>
    <div v-if="activeImage" class="active-image">
      <Video
        v-if="activeImage?.mediaContentType === 'VIDEO'"
        :video="activeImage"
      />
      <Picture v-else :images="activeImage" @click="handleImageClick" />
    </div>
  </div>
  <ImageViewer
    v-if="isImageViewerOpen"
    :image="imageViewerImage"
    @close="isImageViewerOpen = false"
  />
</template>

<script>
import { mapState } from "vuex";
import { unwrapNodes } from "@/helpers/graphql";
import Picture from "@/components/Picture.vue";
import Video from "@/components/Video.vue";
import ImageViewer from "@/components/product-display/ImageViewer.vue";

export default {
  name: "ProductGalleryDesktop",
  components: {
    Picture,
    Video,
    ImageViewer,
  },
  inject: ["mq"],
  data() {
    return {
      activeImage: {},
      isImageViewerOpen: false,
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    images() {
      const medias = this.product.media
        ? unwrapNodes(this.product.media.edges)
        : [];
      const video = medias.find((media) => media.mediaContentType === "VIDEO");

      const allImages = this.product.images
        ? unwrapNodes(this.product.images?.edges)
        : [];
      const imagesWithoutFacebook = allImages.filter(
        (image) => image.altText !== "fb-feed"
      );

      if (video && this.mq.mdPlus) {
        imagesWithoutFacebook.splice(1, 0, video);
      }

      return imagesWithoutFacebook;
    },
  },
  mounted() {
    this.activeImage = this.images[0];
  },
  methods: {
    setActiveImage(image) {
      this.activeImage = image;
    },
    getThumbnailSrcset(image) {
      const retinaSrc = image.thumbnail2x || image.previewImage?.url || false;
      return retinaSrc ? `${retinaSrc} 2x` : "";
    },
    getThumbnailSrc(image) {
      return image.thumbnail || image.previewImage?.url || false;
    },
    handleImageClick() {
      this.imageViewerImage = {
        blurry: this.activeImage.thumbnail,
        url: this.activeImage.imageViewerDesktop,
      };
      this.isImageViewerOpen = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.gallery-wrapper {
  display: grid;
  grid-template-columns: 80px auto;
  gap: 20px;
}

.active-image {
  ::v-deep(.image) {
    cursor: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' fill='none'%3E%3Cpath fill='%23000' d='M27 21h-6v6h-2v-6h-6v-2h6v-6h2v6h6v2Z'/%3E%3Crect width='39' height='39' x='.5' y='.5' stroke='%23070707' rx='19.5'/%3E%3C/svg%3E")
        20 20,
      pointer;
  }
}

.thumbnail__list {
  & > .thumbnail {
    display: block;
    outline: none;
    border: none;
    background: none;
    padding: 0;
    margin-bottom: 10px;
    border: 1px solid transparent;

    &.thumbnail--active {
      border: 1px solid $color-dark;
    }

    .thumbnail__image {
      display: block;
      width: 80px;
    }
  }
}

::v-deep(.video__wrapper) {
  height: auto;
}
</style>
